import React from "react";
import { Link } from "react-router-dom";
import img from "./imgs/logo_black.png";
import "./LoginForm.css";

function LoginForm({
  formData,
  errors,
  isSubmitting,
  onChange,
  onSubmit
}) {
  return (
    <div className="login-container">
      <div className="login-logo">
        <img src={img} alt="logo" width="200px" />
      </div>

      <form className="login-box" onSubmit={onSubmit}>
        <h2>تسجيل الدخول</h2>

        <div className="input-group">
          <label>اسم المستخدم</label>
          <input
            type="text"
            name="username"
            value={formData.username}
            onChange={onChange}
            placeholder="ادخل اسم المستخدم"
          />
          {errors.username && (
            <small className="error-text">{errors.username}</small>
          )}
        </div>

        <div className="input-group">
          <label>كلمة المرور</label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={onChange}
            placeholder="••••••••"
          />
          {errors.password && (
            <small className="error-text">{errors.password}</small>
          )}
        </div>

        {errors.general && (
          <small className="error-text">{errors.general}</small>
        )}

        <button type="submit" className="login-btn" disabled={isSubmitting}>
          {isSubmitting ? (
            <>
              <span className="loading"></span> جارٍ التحقق...
            </>
          ) : (
            "تسجيل الدخول"
          )}
        </button>
        <Link to="/reset-password">تغيير كلمة المرور؟</Link>
      </form>
    </div>
  );
}

export default LoginForm;
